/**
 * THIS FILE IS AUTO-GENERATED — DO NOT EDIT MANUALLY.
 *
 * It contains a static lookup table that maps every MIME type in `EMimeType`
 * to its known file extensions, sourced from the `mime-db` npm package.
 *
 * Why a static lookup instead of importing `mime-db` at runtime?
 * ----------------------------------------------------------------
 * `mime-db` covers thousands of MIME types, but the application only uses a
 * small fraction of them (those declared in `EMimeType`). Bundling the entire
 * `mime-db` database into the client would add unnecessary weight. This file
 * contains only the entries we actually need, keeping the bundle lean while
 * still using `mime-db` as the authoritative source of truth at generation time.
 *
 * To regenerate this file, run the following command from the
 * `services/frontend` directory:
 *
 *   yarn generate:mime-db
 *
 * You should re-run the generator whenever:
 *  - A new entry is added to `src/types/mime.ts` (EMimeType)
 *  - The `mime-db` dependency is upgraded to a newer version
 *
 * Generator script: scripts/generate-mime-type-db.ts
 */

import type { EMimeType } from '@/types/mime.ts';

/**
 * Static lookup of known file extensions for each supported MIME type.
 * Generated from mime-db v1.54.0.
 */
export const MIME_TYPE_EXTENSIONS: Record<EMimeType, string[]> = {
  'image/gif': ['gif'],
  'image/jpeg': ['jpg', 'jpeg', 'jpe'],
  'image/png': ['png'],
  'image/svg+xml': ['svg', 'svgz'],
  'image/tiff': ['tif', 'tiff'],
  'image/webp': ['webp'],
  'video/quicktime': ['qt', 'mov'],
  'video/mp4': ['mp4', 'mp4v', 'mpg4'],
  'video/ogg': ['ogv'],
  'video/webm': ['webm'],
  'audio/aac': ['adts', 'aac'],
  'audio/flac': ['flac'],
  'audio/mpeg': ['mpga', 'mp2', 'mp2a', 'mp3', 'm2a', 'm3a'],
  'audio/ogg': ['oga', 'ogg', 'spx', 'opus'],
  'audio/wav': ['wav'],
  'text/markdown': ['md', 'markdown'],
  'application/vnd.ms-powerpoint': ['ppt', 'pps', 'pot'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['pptx'],
  'application/msword': ['doc', 'dot'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['docx'],
  'application/pdf': ['pdf'],
  'text/csv': ['csv'],
  'application/json': ['json', 'map'],
  'application/vnd.ms-excel': ['xls', 'xlm', 'xla', 'xlc', 'xlt', 'xlw'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['xlsx'],
};
